import React, { type FC } from "react";
import type { ApiMeasure } from "@src/api/dictionaries/measures";
import { BusinessDateValue, BusinessMeasureValue } from "@src/components/business-data-display";
import { DetailList, DetailRow } from "@shared/ui/detail-row";
import type { GroupedMovementItem } from "../../helpers/groupMovements";
import "./WsDepotCardMoveContent.scss";

/** Пропсы просмотра движения цеховой номенклатуры (content для mobile window). */
export interface WsDepotCardMoveContentProps {
    /** Движение для отображения. */
    movement: GroupedMovementItem;
    /** Номер цеховой карточки. */
    cardNumber: string;
    /** Единица измерения карточки. */
    measure?: ApiMeasure;
}

/**
 * Просмотр движения цеховой номенклатуры.
 */
export const WsDepotCardMoveContent: FC<WsDepotCardMoveContentProps> = ({ movement, measure }) => {
    return (
        <DetailList className="ws_depot_card_move_content">
            <DetailRow
                label="Дата движения"
                value={<BusinessDateValue value={`${movement.MoveDate}`} preset="dateTimeSeconds" />}
            />
            <DetailRow label="Документ" value={movement.DocType?.ShortName ?? ""} />
            <DetailRow label="Приход" value={<BusinessMeasureValue value={movement.Arrival} measure={measure} />} />
            <DetailRow label="Расход" value={<BusinessMeasureValue value={movement.Leave} measure={measure} />} />
            <DetailRow label="Остаток" value={<BusinessMeasureValue value={movement.Remainder} measure={measure} />} />
        </DetailList>
    );
};
